export const clamp = (value: number, min: number, max: number) => Math.min(Math.max(value, min), max);

export const clampWithOvershoot = (x: number, min: number, max: number, maxOvershoot = Math.PI / 2) => {
  const overshootAmplitude = maxOvershoot / (Math.PI / 2);

  if (x < min) {
    return min + Math.atan((x - min) / overshootAmplitude) * overshootAmplitude;
  }
  if (x > max) {
    return max + Math.atan((x - max) / overshootAmplitude) * overshootAmplitude;
  }
  return x;
};
